export default "__VITE_ASSET__lAJByVsu__"